<template>
  <v-container fluid scroll-region transition="scroll-x-transition">
    <v-row align="center">
      <template v-for="block in template">
        <component
          :is="block.component"
          :key="block.uid"
          v-model="form[block.uid]"
          :block="block"
        />
      </template>
    </v-row>
    <v-row align="center">
      <v-col cols="12 pa-0">
        <v-btn block text class="bar-btn primary_light white--text" large @click="save">
          Speichern
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Layout from '@/Layouts/Default'

export default {
   metaInfo () {
      // don't know your return object structure,
      // maybe you should check whole this.getViewPage
      return {
         title: this.title ? this.title : 'Loading...',
      }
   },
   provide () {
      const returnobject = {}
      for (const key in this.toProvide) {
         returnobject[key] = () => this.toProvide[key]
      }
      return returnobject
   },
   layout: (h, page) => h(Layout, [page]),

   props: {
      template: {
         type: Array,
         required: true,
      },
      old: {
         type: Object,
         required: true,
      },
      title: {
         type: String,
         required: true,
      },
      offerData: {
         type: Object,
         required: true,
      },
      provide: {
         type: Object,
         default () { return {} }
      }
   },

   data () {
      return {
         panel: [],
         user: 0,
         sending: false,
         form: null,
      }
   },
   computed: {
      toProvide: function () {
         return this.provide
      }
   },
   watch: {
      user: function (val, oldVal) {
         val = parseInt(val)
         oldVal = parseInt(oldVal)
         if (val === 0) {
            this.form = []
         } else {
            if (oldVal > val) {
               this.form = this.form.slice(0, val)
            } else {
               for (let index = oldVal; index < val; index++) {
                  this.standorte.push({
                     zip: null,
                     city: null,
                     street: null,
                     house_number: null,
                     country: 'DE',
                     contact_person: {
                        form_of_address: null,
                        first_name: null,
                        last_name: null,
                        telephone: null,
                        email: null,
                     },
                  })
               }
            }
         }
      },
   },
   created () {
      this.form = this.$inertia.form(this.old)
   },
   methods: {
      save () {
         this.form.post(this.route('bca.store', [this.offerData.id]), {
            preserveScroll: true,
         })
      },
   },
}
</script>

<style>
</style>
